import { FC, ReactNode } from "react";
import { IconType } from "enums/Icon";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Icon from "../../../components/Icon/Icon";
import { iconButtonStyles } from "../../../components/IconButton";

// The back arrow of a drawer heading. Alone it is a compact icon button; with
// a label (the parcel it goes back to) the label is part of the button.
const Wrapper = styled.button<{ $compact: true; $hasLabel: boolean }>`
  ${iconButtonStyles}
  gap: 4px;
  /* The glyph lines up with the heading's text edge; the box adds no height. */
  margin: -4px 2px -4px -6px;
  font: inherit;

  ${({ $hasLabel }) =>
    $hasLabel &&
    `
      width: auto;
      padding: 0 6px;
    `}
`;

interface PanelBackButtonProps {
  onClick: () => void;
  children?: ReactNode;
  className?: string;
}

const PanelBackButton: FC<PanelBackButtonProps> = ({
  onClick,
  children,
  className,
}) => {
  const { t } = useTranslation("common");

  return (
    <Wrapper
      type="button"
      $compact
      $hasLabel={!!children}
      aria-label={children ? undefined : t("common.back")}
      title={t("common.back")}
      className={className}
      onClick={onClick}
    >
      <Icon type={IconType.Arrow} />
      {children}
    </Wrapper>
  );
};

export default PanelBackButton;
